import {
	Button,
	Grid,
	MenuItem,
	Typography,
	makeStyles,
} from "@material-ui/core";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DecodedJWT, ReactHookFormSelect } from "../../utils";

const useStyles = makeStyles((theme) => ({
	optionDiv: {
		gap: theme.spacing(1),
		backgroundColor: "white",
		padding: theme.spacing(1),
		marginBottom: theme.spacing(3),
		boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
		borderRadius: "5px 5px 5px 5px",
		[theme.breakpoints.down("xs")]: {
			gap: 0,
		},
	},
	button: {
		height: "3.3rem",
		width: "6rem",
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginBottom: theme.spacing(4),
		},
	},
}));

export const OptionHandle = ({
	stateOption,
	handleSearch,
	state,
	setState,
	MultiHandleOptionsTask,
}) => {
	const { handleSubmit, errors, control } = useForm();
	const decode = DecodedJWT();
	useEffect(() => {
		MultiHandleOptionsTask({
			params: {
				id: decode.id,
				idlayanan: state.idlayanan,
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.idlayanan]);

	const classes = useStyles();

	return (
		<div style={{ paddingTop: "1rem" }}>
			<Grid container alignItems="center" className={classes.optionDiv}>
				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idlayanan"
						name="idlayanan"
						label="Pilih Layanan"
						control={control}
						error={errors.idlayanan}
						value={state.idlayanan}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID layanan tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						isForm
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="none" disabled selected>
							--Pilih Layanan--
						</MenuItem>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						{stateOption.option1 &&
							stateOption.option1.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idlayanan && (
						<Typography variant="caption" color="error">
							{errors.idlayanan.message}
						</Typography>
					)}
				</Grid>
				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idstatus"
						name="idstatus"
						label="Pilih Status"
						control={control}
						error={errors.idstatus}
						value={state.idstatus}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID Status tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="none" disabled selected>
							--Pilih Status--
						</MenuItem>
						<MenuItem value="1" disable></MenuItem>
						{stateOption.option2 &&
							stateOption.option2.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idstatus && (
						<Typography variant="caption" color="error">
							{errors.idstatus.message}
						</Typography>
					)}
				</Grid>
				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idkategori"
						name="idkategori"
						label="Pilih Kategori"
						control={control}
						error={errors.idkategori}
						value={state.idkategori}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID Kategori tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="none" disabled selected>
							--Pilih Kategori--
						</MenuItem>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						{stateOption.optionResult &&
							stateOption.optionResult.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idkategori && (
						<Typography variant="caption" color="error">
							{errors.idkategori.message}
						</Typography>
					)}
				</Grid>
				<Grid item xs={12} sm={2} md={2}>
					<Button
						variant="contained"
						color="primary"
						className={classes.button}
						onClick={handleSubmit(handleSearch)}
					>
						Filter
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default OptionHandle;
